import React from 'react';
import ContactsPanel from '../contacts/ContactsPanel';
import ErrorComponent from '../ErrorComponent';


class ContactsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: []
    };
  }

  render() {
    return (
      <div>
        <ErrorComponent error={this.state.errors}/>
        <ContactsPanel company_id={this.props.match.params.companyId} onError={(e) => this.setState({errors: e.errors})}/>
      </div>
    );
  }
}

export default ContactsPage;


// WEBPACK FOOTER //
// ./src/components/contacts/ContactsPage.js